import { YoutubeLogoIcon } from '@phosphor-icons/react';

const LearnMore = () => {
  return (
    <button
      style={{
        display: 'flex',
        padding: '4px 6px',
        alignItems: 'center',
        gap: '0px',
        borderRadius: '9999px',
        background: 'var(--q3-surface-dim)',
        color: 'var(--q3-accent-normal)',
        fontFamily: 'Inter',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: '500',
        lineHeight: '16px',
        border: 'none',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
      }}
    >
      <YoutubeLogoIcon size={16} weight="regular" color="var(--q3-accent-normal)" style={{ marginRight: '4px' }} />
      Learn more
    </button>
  );
};

export default LearnMore;
